import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-default-manage-preferences',
  templateUrl: './default-manage-preferences.component.html',
  styleUrls: ['./default-manage-preferences.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DefaultManagePreferencesComponent {
  @Input() scope;

}
